import React, { useMemo, useState } from 'react';
import clsx from 'clsx';
import CrawlHealthRoute from '../features/operations/CrawlHealthRoute';
import AwardIngestionRoute from '../features/operations/AwardIngestionRoute';
import styles from './OperationsHub.module.css';

type OperationsTab = 'award' | 'crawl';

const TABS: Array<{ id: OperationsTab; label: string }> = [
  { id: 'award', label: 'Award Ingestion' },
  { id: 'crawl', label: 'Crawl Health' },
];

const OperationsHub: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [activeTab, setActiveTab] = useState<OperationsTab>('award');

  const ActiveView = useMemo(() => {
    return activeTab === 'award' ? AwardIngestionRoute : CrawlHealthRoute;
  }, [activeTab]);

  return (
    <div className={clsx(styles.root, className)}>
      <nav className={styles.tabBar} aria-label="Operations views">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={clsx(styles.tabButton, activeTab === tab.id && styles.tabButtonActive)}
            onClick={() => setActiveTab(tab.id)}
            aria-pressed={activeTab === tab.id}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className={styles.viewWrapper}>
        <ActiveView />
      </div>
    </div>
  );
};

export default OperationsHub;
